export default {"src":"/_next/static/media/6.11382d3a.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};